import "./column-components.746beab7.js";
import "./column-components.df0ea532.js";
import "./column-components.9afb6b26.js";
import "./column-components.511bed71.js";
import {forwardRef as $iIchK$forwardRef, useContext as $iIchK$useContext} from "react";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;


var $4bJ9d = parcelRequire("4bJ9d");

var $dl5CL = parcelRequire("dl5CL");

var $d6XIX = parcelRequire("d6XIX");

var $fwzVu = parcelRequire("fwzVu");
const $1f6f8b01a1fba95b$export$ae56508882661985 = (0, $iIchK$forwardRef)(function(props, ref) {
    let { offsetY: offsetY, noteHeight: noteHeight, onClick: onClick, children: children } = props;
    const { width: width, paddingLeft: paddingLeft } = (0, $iIchK$useContext)((0, $dl5CL.NoteLayoutContext));
    if (noteHeight == null) noteHeight = 0;
    const outerPad = 5;
    let y = offsetY - noteHeight / 2 - outerPad;
    return (0, $4bJ9d.default)((0, $fwzVu.ForeignObject), {
        width: width - paddingLeft + 2 * outerPad,
        x: paddingLeft - outerPad,
        y: y,
        height: noteHeight + 2 * outerPad,
        overflow: "visible",
        style: {
            overflowY: "visible"
        }
    }, [
        (0, $4bJ9d.default)("div.note-inner", {
            ref: ref,
            onClick: onClick,
            style: {
                margin: outerPad
            }
        }, children)
    ]);
});
const $1f6f8b01a1fba95b$var$findIndex = function(note) {
    const { notes: notes } = (0, $iIchK$useContext)((0, $dl5CL.NoteLayoutContext));
    return notes.indexOf(note);
};
const $1f6f8b01a1fba95b$export$a05ee380fe56e446 = function(props) {
    let { note: note, node: node, deltaConnectorAttachment: deltaConnectorAttachment, index: index } = props;
    // Try to avoid scanning for index if we can
    if (index == null) index = $1f6f8b01a1fba95b$var$findIndex(note);
    const { nodes: nodes, columnIndex: columnIndex, generatePath: generatePath } = (0, $iIchK$useContext)((0, $dl5CL.NoteLayoutContext));
    const { height: height, top_height: top_height } = note;
    if (node == null) node = nodes[note.id];
    if (node != null && deltaConnectorAttachment != null) node.currentPos += deltaConnectorAttachment;
    const offsetX = (columnIndex[index] || 0) * 5;
    return (0, $4bJ9d.default)([
        (0, $4bJ9d.default)((0, $d6XIX.HeightRangeAnnotation), {
            offsetX: offsetX,
            height: height,
            top_height: top_height
        }),
        (0, $4bJ9d.default)("path.link.col-note-link", {
            d: generatePath(node, offsetX),
            transform: `translate(${offsetX})`
        })
    ]);
};


export {$1f6f8b01a1fba95b$export$ae56508882661985 as NotePositioner, $1f6f8b01a1fba95b$export$a05ee380fe56e446 as NoteConnector};
//# sourceMappingURL=column-components.0f346a0e.js.map
